<script>
import dialog2Mixin from '../mixins/dialog2'

export default {
  mixins: [dialog2Mixin],
  data() {
    return {
      storeTitle: '',
      imageUrl: '',
      licenseNo: '',
    }
  },
}
</script>

<template>
  <el-dialog
    :visible.sync="dialog2MixinVisible"
    :custom-class="`${$style.dialogPetBusinessLicense} isStyleBase text-center`"
    width="582px"
    append-to-body
    @closed="$Dialog2MixinOnDestroy"
  >
    <div class="dialogPetBusinessLicense__title">
      <div class="d-flex justify-content-center flex-wrap">
        <span v-if="storeTitle" class="mr-2">{{ storeTitle }}</span>
        <span>特寵業許可證</span>
      </div>
      <div
        v-if="licenseNo"
        class="dialogPetBusinessLicense__licenseNo"
      >
        特寵業字號：{{ licenseNo }}
      </div>
    </div>
    <div
      v-if="imageUrl"
      class="dialogPetBusinessLicense__imageBox"
    >
      <img
        class="dialogPetBusinessLicense__image"
        :src="imageUrl"
        :alt="storeTitle ? `${storeTitle} 特寵業許可證` : '特寵業許可證'"
      >
    </div>
    <BaseButton
      class="isStylePrimary isRadius isFull"
      @click="dialog2MixinVisible = false"
    >
      關閉視窗
    </BaseButton>
  </el-dialog>
</template>

<style lang="scss" module>
.dialogPetBusinessLicense {
  :global {
    .dialogPetBusinessLicense {
      &__title {
        margin-bottom: 1.5rem;
        font-size: 1.5rem;
        font-weight: 600;
        line-height: 1.5;
      }

      &__licenseNo {
        margin-top: 0.5rem;
        font-size: 0.875rem;
        font-weight: 400;
        color: $color-gray-2;
      }

      &__imageBox {
        margin: 0 auto 2rem;
        max-width: 100%;
      }

      &__image {
        display: block;
        width: 100%;
        height: auto;
        max-height: 70vh;
        object-fit: contain;
      }
    }
  }
}
</style>
